import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import useStyles from '../useStyles';
import { Popper, ClickAwayListener, IconButton, TextField, InputAdornment } from '@mui/material';
import BookmarksOutlinedIcon from '@mui/icons-material/BookmarksOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';

function TemplatePicker({ setBody, userOptions }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const anchor = useRef(null);

  const classes = useStyles();

  function handleClick(template) {
    setBody(template.body);
    setIsOpen(false);
  }

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <div>
        <IconButton
          classes={{ root: classes.actionButton }}
          ref={anchor}
          onClick={() => setIsOpen(!isOpen)}
        >
          <BookmarksOutlinedIcon fontSize="small" color="primary" />
        </IconButton>
        <Popper
          className={`${classes.popper} ${classes.popperTemplate}`}
          anchorEl={anchor.current}
          open={isOpen}
          placement="top-start"
          popperOptions={{ positionFixed: true }}
        >
          <TextField
            className={classes.textField}
            type="string"
            placeholder="Search templates"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlinedIcon />
                </InputAdornment>
              )
            }}
          />
          {userOptions && userOptions.templates ? (
            userOptions.templates
              .filter((template) => template.title.toLowerCase().includes(searchTerm))
              .map((template) => (
                <div
                  key={template.id}
                  className={classes.popperItemTemplate}
                  onClick={() => handleClick(template)}
                >
                  <h4>{template.title}</h4>
                  <span>{template.body}</span>
                </div>
              ))
          ) : (
            <div className={`${classes.popperItemTemplate} ${classes.noHover}`}>
              <h4>No templates</h4>
            </div>
          )}
        </Popper>
      </div>
    </ClickAwayListener>
  );
}

TemplatePicker.propTypes = {
  setBody: PropTypes.func.isRequired,
  userOptions: PropTypes.object.isRequired
};

export default TemplatePicker;
